// Franjas fijas de modo: nunca se pueden cerrar. Si algo corre "de mentiras" o sin seguridad, se ve siempre.
// En el celular solo va el nombre del modo; en la computadora, también la explicación.
import type { ConfigPublica } from '@cotizador/compartido';
import { transporteSimulado } from '../api/cliente.ts';

function Franja({ clase, nombre, detalle }: { clase: string; nombre: string; detalle: string }) {
  return (
    <div className={`franja ${clase}`} role="status">
      <strong>{nombre}</strong>
      <span className="franja__detalle"> · {detalle}</span>
    </div>
  );
}

export function FranjaApiSimulada() {
  if (!transporteSimulado()) return null;
  return <Franja clase="franja--api" nombre="API SIMULADA" detalle="datos inventados en este navegador; nada llega al servidor" />;
}

export function hayFranjas(config: ConfigPublica | null): boolean {
  return (
    transporteSimulado() ||
    Boolean(config?.acceso.modo_desarrollo) ||
    config?.ia.modo === 'simulado' ||
    Boolean(config?.almacenamiento.efimero) ||
    Boolean(config?.almacenamiento.lecturas?.saltado) ||
    Boolean(config?.almacenamiento.lecturas?.entradas_cerradas) ||
    Boolean(config?.almacenamiento.lecturas?.apagado)
  );
}

export function Franjas({ config }: { config: ConfigPublica }) {
  if (!hayFranjas(config)) return null;
  return (
    <div className="franjas">
      <FranjaApiSimulada />
      {(config.almacenamiento.lecturas?.saltado || config.almacenamiento.lecturas?.apagado) && (
        <Franja
          clase="franja--desarrollo"
          nombre={
            config.almacenamiento.lecturas.apagado
              ? 'EL COTIZADOR SE APAGÓ HASTA MAÑANA'
              : config.almacenamiento.lecturas.detenido
                ? 'LA BASE SE DETUVO HASTA MAÑANA'
                : 'TOPE DE LECTURAS DE HOY'
          }
          detalle={
            config.almacenamiento.lecturas.apagado
              ? 'se leyó 4 veces más de lo normal; avísale a Diego'
              : config.almacenamiento.lecturas.detenido
                ? 'se leyó 3 veces más de lo normal; avísale a Diego'
                : 'la lista y la búsqueda no responden hasta mañana; abrir una cotización sí. Avísale a Diego'
          }
        />
      )}
      {config.almacenamiento.lecturas?.entradas_cerradas && (
        <Franja
          clase="franja--desarrollo"
          nombre="ENTRADAS NUEVAS CERRADAS HOY"
          detalle="hubo demasiados intentos de entrar sin sesión; quien ya entró sigue trabajando. Avísale a Diego"
        />
      )}
      {config.almacenamiento.efimero && (
        <Franja
          clase="franja--desarrollo"
          nombre="ENSAYO: SE BORRA AL APAGARSE"
          detalle="lo que captures aquí se pierde cuando el servidor se apague, también el gasto de IA del mes (su tope es por arranque); usa solo datos inventados"
        />
      )}
      {config.acceso.modo_desarrollo && <Franja clase="franja--desarrollo" nombre="MODO DESARROLLO" detalle="el enlace de entrada se ve en pantalla; no uses esto fuera de esta Mac" />}
      {config.ia.modo === 'simulado' && <Franja clase="franja--ia" nombre="IA SIMULADA" detalle="las lecturas y revisiones son de prueba, no de tus recibos" />}
    </div>
  );
}
